import {CustomerDocumentType} from '../../interfaces/customer-documents/customer-document-type';


export class CustomerDocumentTypeFactory {
  /**
   *
   * @param customerDocumentType
   */
  public static fromObject(customerDocumentType: any): CustomerDocumentType {
    return new class implements CustomerDocumentType {
      color: string = customerDocumentType.color;
      id: number= customerDocumentType.id;
      isConfirmationNeeded: boolean= customerDocumentType.is_confirmation_needed;
      name: string= customerDocumentType.name;
      rights: number= customerDocumentType.rights;
      serviceFacilityIds: number[] = customerDocumentType.service_facility_ids;
    };
  }

  /**
   *
   * @param customerDocumentTypes
   */
  public static fromArray(customerDocumentTypes: any[]): CustomerDocumentType[] {
    return customerDocumentTypes.map(_customerDocumentType => this.fromObject(_customerDocumentType));
  }
}